/* eslint-disable no-param-reassign */
import axios from 'axios';
import { store } from 'store/index';
import { REFRESH_TOKEN, LOGOUT } from 'store/reducers/auth';
import { CLEAR } from 'store/reducers/catalogs';
import { CLEAN } from 'store/reducers/app';

const {
  REACT_APP_SCHEME: SCHEME,
  REACT_APP_APIHOST: APIHOST,
  REACT_APP_PATH: PATH,
} = process.env;

export const baseURL = `${SCHEME}://${APIHOST}${PATH}`;
const timeout = 60 * 60 * 10;

const defaultOptions = {
  baseURL,
  timeout,
  headers: {
    'Content-Type': 'application/json',
  },
};

const http = axios.create(defaultOptions);

const getProp = (data = {}, prop = null) => (data.get?.(prop) || data[prop]);

http.interceptors.request.use((options) => {
  const { data } = { ...options };
  if (['post', 'put', 'patch'].includes(options.method) && data) {
    const numero = getProp(data, 'numero_de_telefono') || getProp(data, 'numero_de_celular')
      || getProp(data, 'telefono');
    const lada = getProp(data, 'lada');
    if (numero) {
      const { lada: ladaDefault } = store.getState().auth.entidad;
      if (!lada) {
        if (data.values) {
          data.append('lada', ladaDefault);
        } else {
          data.lada = ladaDefault;
        }
      }
      options.data = data;
    }
  }
  const { token } = store.getState().auth;
  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }
  if (options.url[options.url.length - 1] !== '/') {
    options.url = `${options.url}/`;
  }

  const source = axios.CancelToken.source();
  options.cancelToken = source.token;
  http.source = source;
  return options;
});

const refresh = async () => {
  try {
    const { refreshToken } = store.getState().auth;
    const res = await http.post('usuarios/refresh-token/', {
      refresh: refreshToken,
    });
    if (res?.status === 200) {
      return res.data.access;
    }
    return false;
  } catch (err) {
    return false;
  }
};

const logout = () => {
  setTimeout(() => {
    store.dispatch({ type: CLEAN });
    store.dispatch({ type: CLEAR });
    store.dispatch({ type: LOGOUT });
  });
};

const handleError = async (err) => {
  const inRefreshToken = err?.config?.url === 'usuarios/refresh-token/';
  if (err?.response && !inRefreshToken) {
    const { response: { data, status } } = err;
    if (data && status === 401) {
      const errorDetail = data.code === 'token_not_valid';
      if (errorDetail) {
        const token = await refresh();
        if (token) {
          const config = { ...err.config };
          config.headers.Authorization = `Bearer ${token}`;
          store.dispatch({
            type: REFRESH_TOKEN,
            payload: token,
          });
          return axios.request(config);
        }
        // TODO: Ask for the password to relogin the user if he wants to keep using the app.
        // Otherwise redirect to login
        logout();
      }
    }
  } else if (inRefreshToken) {
    logout();
  }
  return Promise.reject(err);
};

http.interceptors.response.use(null, handleError);

http.tryCancel = () => {
  if (http.source?.cancel) {
    http.source.cancel();
  }
};

export const baseAPI = axios.create({ timeout });

export default http;
